import env from 'common/env';

export async function index(merchantId, payload) {
    const formData = new FormData();
    formData.append('order', payload?.order ?? 'asc');
    formData.append('orderBy', payload?.orderBy ?? 'aot.label');
    formData.append('page', payload?.page ?? 1);
    formData.append('merchant_id', merchantId);

    const result = await fetch(`${env}/common/merchant/aot-merchants/`, {
        method: 'POST',
        body: formData
    })
        .then(response => (response.ok ? response.json() : false))
        .then(res => res)
        .catch(error => {
            console.error(error);
            throw 'Echec de la récupération des aots';
        });

    return result;
}

export async function shareByMail(aotMerchantId) {
    const result = await fetch(`${env}/common/merchant/aot-merchants/${aotMerchantId}/share/mail`)
        .then(response => (response.ok ? response.json() : false))
        .then(res => res)
        .catch(error => {
            console.error(error);
            throw "Echec de l'envoie de l'aot";
        });

    return result;
}

export function pdf(aotMerchantId) {
    window.open(`${env}/common/merchant/aot-merchants/${aotMerchantId}/export.pdf`, '_blank');
}
